export default __webpack_public_path__ + "partialExcludedNoBorder.svg?fedc5e6efc8094b528c41c583b74cdb2";